// extracted by mini-css-extract-plugin
export default {"calendarPopup":"Receipt_calendarPopup__txdsJ"};